/**
 * Drops named by their row number in the list ("#5, #27–33") — the number
 * the Drop slots list shows, i.e. the drop's place in time order, never its
 * draft position.
 * For Media Devoted | Created By Ciro Autiero
 */

/** `indexes` = draft positions; `timeOrder` = draft positions in the order the list reads. */
export function positionsLabel(indexes: number[], timeOrder: number[]): string {
  const rowOf = new Map(timeOrder.map((index, k) => [index, k + 1]));
  const rows = indexes.map((i) => rowOf.get(i) ?? i + 1).sort((a, b) => a - b);
  const runs: string[] = [];
  for (let k = 0; k < rows.length; ) {
    let end = k;
    while (end + 1 < rows.length && rows[end + 1] === rows[end] + 1) end += 1;
    runs.push(end === k ? `#${rows[k]}` : `#${rows[k]}–${rows[end]}`);
    k = end + 1;
  }
  return runs.join(', ');
}
